module.exports = __webpack_public_path__ + "img/qzb.2027698a.svg";